import { createFileRoute } from "@tanstack/react-router";
import { ProductViewsPage } from "@/components/views/ProductViewsPage";

export const Route = createFileRoute("/_app/p/$productKey/views")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  return <ProductViewsPage productKey={productKey} />;
}
